var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDtu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 751.18 582.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#865c63;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4237",
    className: "cls-1",
    d: "M751.18,168.2,591.33,252.12c-207.06-80.52-224.5-80.52-431.49,0L0,168.2,159.84,84.27c207,80.52,224.43,80.52,431.49,0Z",
    transform: "translate(0 -84.27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4239",
    className: "cls-1",
    d: "M751.18,375.62,591.33,459.55c-207.06-80.53-224.5-80.53-431.49,0L0,375.62l159.84-83.91c207,80.52,224.43,80.52,431.49,0Z",
    transform: "translate(0 -84.27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4241",
    className: "cls-1",
    d: "M751.18,583,591.33,666.91c-207.06-80.52-224.5-80.52-431.49,0L0,583l159.84-83.85c207,80.52,224.43,80.52,431.49,0Z",
    transform: "translate(0 -84.27)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtu);
export default __webpack_public_path__ + "static/media/dtu.52034e73ed9b8f16e5dad3047d4c92d4.svg";
export { ForwardRef as ReactComponent };